import moment from 'moment';
import randomColor from 'randomcolor';

// We can use "process.env.VAR_NAME" on both the server and the client.
// See config/env.js and server/indexHtml.js
export function imagePath(assetName) {
  return `${process.env.PUBLIC_URL}/images/${assetName}`;
}

export const getErrorType = (data, code) => {
  const error = data.filter(item => item.code === code);
  return error[0].name;
};

export const mappingState = data => {
  let states = data.job_states || [];
  states.sort((a, b) => a.priority - b.priority);
  for (let i = 0; i < states.length; i++) {
    states[i].list = [];
    for (let j = 0; j < data.jobs.length; j++) {
      if (
        data.jobs[j].running_state &&
        data.jobs[j].running_state.state === states[i].name
      ) {
        const { name, running_state, server } = data.jobs[j];
        states[i].list.push({
          name,
          state: (running_state && running_state.state) || null,
          started: (running_state && running_state.start_time) || null,
          current: (running_state && running_state.current_time) || null,
          updated: (running_state && running_state.updated_at) || null,
          server: (server && server.name) || null,
          url: (server && server.url) || null
        });
      }
    }
  }
  return states;
};

export const cpParser = data => {
  const cps = [];
  const tempCpIds = [];
  const accounts = [];
  const tempAccountIds = [];
  for (let index = 0; index < data.length; index++) {
    if (tempCpIds.indexOf(data[index].courier_partner__id) < 0) {
      tempCpIds.push(data[index].courier_partner__id);
      cps.push({
        id: data[index].courier_partner__id,
        name: data[index].courier_partner__name
      });
    }
    if (tempAccountIds.indexOf(data[index].id) < 0) {
      tempAccountIds.push(data[index].id);
      accounts.push({
        id: data[index].id,
        name: data[index].account_name,
        cp_id: data[index].courier_partner__id,
        cp_name: data[index].courier_partner__name
      });
    }
  }
  return { cps, accounts };
};

export const activeCpsParser = data => {
  const cps = [];
  const tempCpIds = [];
  for (let index = 0; index < data.length; index++) {
    if (tempCpIds.indexOf(data[index].partner_id) < 0) {
      tempCpIds.push(data[index].partner_id);
      cps.push({
        id: data[index].partner_id,
        name: data[index].cp_name
      });
    }
  }
  return { cps };
};

export const getBase64 = (file, cb) => {
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function() {
    cb(reader.result);
  };
  reader.onerror = function(error) {
    // eslint-disable-next-line no-console
    console.log('Error: ', error);
  };
};

export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

export const parseQueryString = queryString => {
  const qs = queryString.replace('?', '');
  const items = qs.split('&');
  return items.reduce((data, item) => {
    const [key, value] = item.split('=');
    if (data[key] !== undefined) {
      if (!Array.isArray(data[key])) {
        data[key] = [data[key]];
      }
      data[key].push(value);
    } else {
      data[key] = value;
    }
    return data;
  }, {});
};

export const generateMonthList = n => {
  let itr = parseInt(
    moment(new Date()).diff(new Date('2018-01-01'), 'months', true) || 6
  );
  var monthList = [];
  if (n) {
    itr = n;
  }
  for (let i = 0; i < itr; i++) {
    const dt = moment().subtract(i, 'M');
    monthList.push({
      label: dt.format('YYYY-MM'),
      value: dt.format('YYYY-MM')
    });
  }
  return monthList;
};

export const groupServiceData = (data, searchedServiceType) => {
  for (let i = 0; i < data.length; i++) {
    var obj = {};
    for (let j = 0; j < data[i].data.length; j++) {
      if (
        searchedServiceType &&
        searchedServiceType.indexOf(data[i].data[j].billing_service__api_type) >
          -1
      ) {
        if (data[i].data[j].billing_service__api_type in obj) {
          obj[data[i].data[j].billing_service__api_type] +=
            data[i].data[j].count;
        } else {
          obj[data[i].data[j].billing_service__api_type] =
            data[i].data[j].count;
        }
      } else if (!searchedServiceType) {
        if (data[i].data[j].billing_service__api_type in obj) {
          obj[data[i].data[j].billing_service__api_type] +=
            data[i].data[j].count;
        } else {
          obj[data[i].data[j].billing_service__api_type] =
            data[i].data[j].count;
        }
      }
    }
    data[i].obj = obj;
    delete data[i].data;
  }
  return data;
};

export const sortObject = obj =>
  Object.keys(obj)
    .sort()
    .reduce((a, v) => {
      a[v] = obj[v];
      return a;
    }, {});

export const trackingDelayParser = (
  data,
  selectedCps,
  cpList,
  isPercentile
) => {
  let uniqueDates = [];
  let obj = {};
  let list = [];
  let cpObj = {};
  let legends = [];
  let colors = [];
  for (let index = 0; index < data.length; index++) {
    if (
      uniqueDates.indexOf(data[index].courier_partner_latest_timestamp) > -1
    ) {
      uniqueDates.push(data[index].courier_partner_latest_timestamp);
    }
  }
  for (let i = 0; i < cpList.length; i++) {
    cpObj[cpList[i].id] = cpList[i].name;
  }
  for (let j = 0; j < data.length; j++) {
    if (selectedCps.length > 0) {
      if (!(data[j].courier_partner_latest_timestamp in obj)) {
        obj[data[j].courier_partner_latest_timestamp] = {
          date: moment(
            data[j].courier_partner_latest_timestamp.substr(0, 16)
          ).format('Do MMM, h:mm a'),
          totalShipments: {}
        };
      }
      for (let k = 0; k < selectedCps.length; k++) {
        if (legends.indexOf(cpObj[selectedCps[k]]) < 0) {
          legends.push(cpObj[selectedCps[k]]);
          colors.push(randomColor());
        }
      }
      obj[data[j].courier_partner_latest_timestamp][
        cpObj[data[j].courier_partner__partner_id]
      ] = data[j][isPercentile ? 'time_lag' : 'total_average_lag'];
      obj[data[j].courier_partner_latest_timestamp].totalShipments[
        cpObj[data[j].courier_partner__partner_id]
      ] = data[j].total_shipments;
    } else {
      obj[data[j].courier_partner_latest_timestamp] = {
        date: moment(
          data[j].courier_partner_latest_timestamp.substr(0, 16)
        ).format('Do MMM, h:mm a'),
        totalShipments: { All: data[j].total_shipments },
        All: data[j][isPercentile ? 'time_lag' : 'total_average_lag']
      };
      legends = ['All'];
      colors[randomColor()];
    }
  }
  obj = sortObject(obj);
  for (const key in obj) {
    list.push(obj[key]);
  }
  return { list, legends, colors };
};

export const ocStatsParser = (data, selectedCps, cpList, day) => {
  data = data.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
  let uniqueDates = [];
  let obj = {};
  let list = [];
  let cpObj = {};
  let legends = [];
  let colors = [];
  for (let index = 0; index < data.length; index++) {
    var date = moment
      .utc(data[index].start_date)
      .format(`Do MMMM HH${day > 0 ? '00' : ':mm'}`);
    if (uniqueDates.indexOf(date) < 0) {
      uniqueDates.push(date);
    }
  }
  for (let i = 0; i < cpList.length; i++) {
    cpObj[cpList[i].id] = cpList[i].name;
  }
  for (let j = 0; j < data.length; j++) {
    var dt = moment
      .utc(data[j].start_date)
      .format(`Do MMMM HH${day > 0 ? ':00' : ':mm'}`);
    if (selectedCps.length > 0) {
      if (!(dt in obj)) {
        obj[dt] = {
          date: dt,
          orders: {}
        };
      }
      for (let k = 0; k < selectedCps.length; k++) {
        if (legends.indexOf(cpObj[selectedCps[k]]) < 0) {
          legends.push(cpObj[selectedCps[k]]);
          colors.push(randomColor());
        }
      }

      obj[dt][cpObj[data[j].courier_partner__partner_id]] =
        data[j].total_success + data[j].total_failed;

      obj[dt].orders[cpObj[data[j].courier_partner__partner_id]] = {
        total: data[j].total_success + data[j].total_failed,
        success: data[j].total_success,
        failed: data[j].total_failed
      };
    } else {
      if (!(dt in obj)) {
        obj[dt] = {
          date: dt,
          orders: {
            All: { total: data[j].total_success + data[j].total_failed || 0 }
          },
          All: data[j].total_success + data[j].total_failed
        };
      }
      if (obj[dt].orders.All && obj[dt].orders.All.success) {
        obj[dt].orders.All.success += data[j].total_success;
      } else {
        obj[dt].orders.All.success = data[j].total_success;
      }
      if (obj[dt].orders.All && obj[dt].orders.All.failed) {
        obj[dt].orders.All.failed += data[j].total_failed;
      } else {
        obj[dt].orders.All.failed = data[j].total_failed;
      }
      legends = ['All'];
      colors = [randomColor()];
    }
  }
  obj = sortObject(obj);
  for (const key in obj) {
    list.push(obj[key]);
  }
  return { list, legends, colors };
};

export const ocStatsChange = (orderCreation, key) => {
  const { list, legends } = orderCreation;
  for (let i = 0; i < list.length; i++) {
    for (let j = 0; j < legends.length; j++) {
      if (legends[j] in list[i]) {
        list[i][legends[j]] = list[i].orders[legends[j]][key];
      }
    }
    list[i][key] = list[i].orders[key];
  }
  return { list, legends };
};

export const getHostname = url => {
  const parsedUrl = new URL(url);
  const hostname = parsedUrl.hostname;
  return hostname;
};

export const csvDownload = ({ header, rows, name, csvData }) => {
  let data =
    header && header.length ? `${header.join(',')}\n${rows.join('\n')}` : '';
  const fileName = `${name}.csv`;
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.classList.add('hidden');
  if (csvData) {
    data = csvData;
  }

  const blob = new Blob([data], { type: 'application/vnd.ms-excel' });
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = fileName;
  a.click();
};

/**
 * Capitalize just the first word.
 * e.g. 'hello world' => 'Hello world'
 */
export const capitalize = (string = '') =>
  [...string]
    ?.map((char, index) => (index ? char.toLowerCase() : char.toUpperCase()))
    ?.join('');

export const snakeOrCamelToWords = val =>
  val
    ? val
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .split('_')
        .map(word => capitalize(word))
        .join(' ')
    : '';

export const toTitleSpaceCase = (string = '') =>
  string
    // Split the string into words based on non-alphanumeric characters
    .match(/[a-zA-Z0-9]+/g)
    // Map each word to capitalize the first letter and lowercase the rest
    ?.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    // Join the words with a space
    .join(' ');

// Helper function to merge items ensuring uniqueness by link
export const mergeUniqueItems = (existingItems, newItems) => {
  // Create a Map with link as the key
  const uniqueMap = new Map();

  // Add existing items to the map
  existingItems.forEach(item => {
    uniqueMap.set(item.link, item);
  });

  // Add or override with new items
  newItems.forEach(item => {
    uniqueMap.set(item.link, item);
  });

  // Convert map values back to array
  return Array.from(uniqueMap.values());
};
